import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Requires an authenticated user AND a valid access key entered this session.
export default function RequireAccess({ children }) {
  const { user, accessGranted } = useAuth();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-arjuna-ink" data-testid="access-loading">
        <Loader2 className="h-7 w-7 animate-spin text-arjuna-teal" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (!accessGranted) return <Navigate to="/access-key" replace />;
  return children;
}
